import styles from "./contactfilter.module.css";
import { Plus, Search } from "react-feather";
import { Link } from "react-router-dom";

const ContactFilter = ({ setFilterData, setAddModalOpen }) => {

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setFilterData(prev => { return { ...prev, searchKey: e.target.value } })} />
            </div>
        </div>

        <div className={`${styles.FilterSec}`}>
            <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
                <Plus /> <span>Contact</span>
            </Link>
        </div>
    </div>);
}

export default ContactFilter;